var map = {
	"./areas-verdes.png": 3594,
	"./buffet.png": 7164,
	"./cadastro-condutores.png": 4216,
	"./cadastro-fretado.png": 9925,
	"./cadastro-fretado2.png": 2851,
	"./carro-executivo.png": 3602,
	"./coleta-seletiva.png": 1306,
	"./credenciamento.png": 7269,
	"./energia.png": 1759,
	"./evento.png": 5099,
	"./guia-vidente.png": 1216,
	"./limpeza-predial.png": 424,
	"./limpeza-urbana.png": 5932,
	"./logo_unicamp_pref.png": 8009,
	"./manut-frota.png": 6631,
	"./manutencao-predial.png": 8667,
	"./manutencao-urbana.png": 4121,
	"./monitoramento-animal.png": 95,
	"./passagem-aerea.png": 4520,
	"./pragas.png": 2914,
	"./refeicao-evento.png": 3144,
	"./refeicao-visitante.png": 4310,
	"./revitalizacao-predial.png": 8798,
	"./saneamento.png": 7003,
	"./sinalizacao.png": 1494,
	"./taxi.png": 6072,
	"./transp-carga.png": 6435,
	"./transp-event.png": 4937,
	"./transp-grupo.png": 2062,
	"./transporte-eventual.png": 9349,
	"./vale-transporte.png": 8457
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;